/**
 * @generated SignedSource<<352bda7fd573f14e62dc83770376291c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type interiorsPhotosTracking_tradePhoto$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "interiorsPhotosTracking_tradePhoto";
};
export type interiorsPhotosTracking_tradePhoto$key = {
  readonly " $data"?: interiorsPhotosTracking_tradePhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"interiorsPhotosTracking_tradePhoto">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "interiorsPhotosTracking_tradePhoto"
};

(node as any).hash = "4076e4cc86f72f95184913cc48d5c02a";

export default node;
